<template>
  <div class="contract-container">
    <div class="tooltip">
      <div class="circle" @click="showTooltip">
        <span class="tooltip-icon">i</span>
      </div>
      <span class="tooltiptext left" :style="visibility">{{ $t('maintenance_message') }}</span>
    </div>
    <oops-icon />
    <h4>{{ $t('whoops') }}</h4>
    <p>{{ $t('contract_warning') }}</p>
  </div>
</template>
<script>
  import Layout from './layout'
  import oopsIcon from '../components/icons/oops-icon.vue'

  export default {
    components: {
      Layout,
      oopsIcon,
    },
    data() {
      return {
        visibility: {},
      }
    },
    methods: {
      showTooltip() {
        this.visibility = { visibility: 'visible' }
        setTimeout(() => {
          this.visibility = {}
        }, 5000) // 5000 milliseconds = 5 seconds
      },
    },
  }
</script>
<style>
  .contract-container {
    width: 600px;
    text-align: center;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    font-family: 'Avenir Next', sans-serif;
  }
  .contract-container p {
    font-size: 17px;
    padding-inline: 20px;
  }
  .tooltip {
    position: absolute;
    top: 11px;
    right: 15px;
    display: inline-block;
    cursor: pointer;
  }
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 200px;
    background-color: #cccccc;
    color: #2b2a2a;
    text-align: center;
    padding: 5px 3px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    margin-top: 5px;
    font-size: 12px;
    font-family: 'Avenir Next', sans-serif;
  }
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
  .left {
    top: -8px;
    right: 120%;
  }
  .circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 5px;
  }
  .tooltip-icon {
    font-size: 20px;
    color: #fff;
  }
</style>
